import React, { useEffect } from "react";
import { ArrowRight, Check, Phone } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FlowLines } from "@/components/site/FlowLines";
import { Container } from "@/components/site/Primitives";
import content from "@/data/content.json";

const { meta } = content;

export default function PersonalDanke() {
  useEffect(() => {
    document.title = "Danke — Ihre Anfrage ist eingegangen | energyleads";
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute("content", "noindex, nofollow");
    if (typeof window.fbq === "function") window.fbq("track", "Lead");
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main data-testid="personal-danke-main">
        <section className="has-lines relative overflow-hidden bg-[#1e2532] pb-24 pt-[150px] text-white on-dark">
          <FlowLines />
          <Container className="max-w-[820px]">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#0f9d6e]">
              <Check size={26} strokeWidth={3} className="text-white" />
            </span>
            <h1 className="mt-8 font-bold" data-testid="personal-danke-h1">
              Danke — Ihre Anfrage ist <span style={{ color: "var(--accent)" }}>eingegangen</span>
            </h1>
            <p className="mt-6 text-[17px] leading-[1.8] text-white/72">
              Wir prüfen Ihre Angaben und melden uns innerhalb von 24 Stunden mit einer ersten Einschätzung zur
              Besetzbarkeit Ihrer Position. Wenn es schneller gehen soll, erreichen Sie uns direkt telefonisch.
            </p>
            <a
              href={meta.phoneHref}
              data-testid="danke-phone"
              className="mt-8 inline-flex items-center gap-3 text-[18px] font-semibold text-[#3ecf9b]"
            >
              <Phone size={18} />
              <span className="link-underline">{meta.phone}</span>
            </a>
            <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2">
              <a href="/personalvermittlung/" className="card-hover rounded-[16px] border border-white/12 bg-white/[0.04] p-7">
                <p className="text-[17px] font-semibold text-white">Alle Rollen ansehen</p>
                <p className="mt-3 text-[15px] leading-[1.7] text-white/60">
                  Elektriker, Elektromeister, Monteure, Vertrieb, SHK und Projektentwickler.
                </p>
                <span className="mt-5 inline-flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.08em] text-[#3ecf9b]">
                  Zur Übersicht <ArrowRight size={15} />
                </span>
              </a>
              <a href="/ratgeber/" className="card-hover rounded-[16px] border border-white/12 bg-white/[0.04] p-7">
                <p className="text-[17px] font-semibold text-white">Ratgeber lesen</p>
                <p className="mt-3 text-[15px] leading-[1.7] text-white/60">
                  Praxiswissen zu Personal, Flächen, Netzanfragen und Projektverkauf.
                </p>
                <span className="mt-5 inline-flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.08em] text-[#3ecf9b]">
                  Zum Ratgeber <ArrowRight size={15} />
                </span>
              </a>
            </div>
          </Container>
        </section>
      </main>
      <Footer />
    </>
  );
}
